import React, {useState, useEffect, useRef} from "react";
import {sweetAlerts} from "../utils/sweet-alerts";
import {UpdateProfile, ChangePassword, GetProfileDetails, SendEmailChangeOtp, VerifyEmailChangeOtp, BusinessVerifyWithPhoneService, VerifyEmailAndBusinessChangeOtpService} from "../services/auth";
import {contractor_role_id, profile_url} from "../constant";
import {GoogleAddress} from "../components/GoogleAddress";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Alert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import {Form, Formik} from "formik";
import * as Yup from "yup";
import CustomBusinessVerified from "../CustomComponents/CustomBusinessVerified";
import CustomBusinessVerifiedMain from "../CustomComponents/CustomBusinessVerifiedMain";

const MyProfile = () => {
	const [activeTab, setActiveTab] = useState("profile");
	const [loading, setLoading] = useState(false);
	// const [submitLoading, setSubmitLoading] = useState(false);
	const [role, setRole] = useState(null);

	useEffect(() => {
		const role = localStorage.getItem("role");
		setRole(role);
	}, []);

	// Profile form data
	const [profileData, setProfileData] = useState({
		first_name: "",
		last_name: "",
		business_name: "",
	});

	// Password change form data
	const [passwordData, setPasswordData] = useState({
		current_password: "",
		new_password: "",
		confirm_password: "",
	});

	// Form errors
	const [profileErrors, setProfileErrors] = useState({});
	const [passwordErrors, setPasswordErrors] = useState({});
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [businessName, setBusinessName] = useState(null);
	const [businessWebsite, setBusinessWebsite] = useState("");
	const [email, setEmail] = useState("");
	const [originalEmail, setOriginalEmail] = useState("");
	const [isEmailEditing, setIsEmailEditing] = useState(false);
	const [isEmailVerified, setIsEmailVerified] = useState(true);
	const [otpSent, setOtpSent] = useState(false);
	const [emailOtp, setEmailOtp] = useState("");
	const [emailActionLoading, setEmailActionLoading] = useState(false);
	const [phone, setPhone] = useState(null);
	const [addressString, setAddressString] = useState("");
	const [googleBusinessListing, setGoogleBusinessListing] = useState("");
	const [uuid, setUuid] = useState("");
	const [userId, setUserId] = useState("");
	const [badge, setBadge] = useState(false);
	const [profileImage, setProfileImage] = useState(null);
	const [profileImagePreview, setProfileImagePreview] = useState(null);
	const [profileImageUrl, setProfileImageUrl] = useState(null);
	const [emailNotificationsEnabled, setEmailNotificationsEnabled] = useState(true);
	const [flagApi, setFlagApi] = useState(true);
	const [phoneOtpLoading, setPhoneOtpLoading] = useState(false);
	// const [submitLoading, setSubmitLoading] = useState(false);
	// const [formSuccess, setFormSuccess] = useState(null);
	// const [formError, setFormError] = useState(null);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [formSuccess, setFormSuccess] = useState(null);
	const [formError, setFormError] = useState(null);

	// Code modal state (shared for email / phone)
	const [otpModal, setOtpModal] = useState({
		open: false,
		target: null, // 'email' | 'phone'
		value: "",
		otp: "",
		loading: false,
		error: null,
	});

	// keep a static +1 prefix; user can only edit digits after +1
	const normalizePhoneInput = (val) => {
		if (val === undefined || val === null) return "+1";
		const digits = val.toString().replace(/[^\d]/g, "");
		const rest = digits.startsWith("1") ? digits.slice(1) : digits;
		return "+1" + rest;
	};

	const handleGetProfileDetails = async (e) => {
		setLoading(true);

		try {
			const response = await GetProfileDetails();

			if (response.status) {
				const userDetails = response?.data || {};
				const userEmail = userDetails?.email || "";

				setFirstName(userDetails?.first_name || "");
				setLastName(userDetails?.last_name || "");
				setBusinessName(userDetails?.business_name || null);
				setBusinessWebsite(userDetails?.business_website || "");
				setEmail(userEmail);
				setOriginalEmail(userEmail);
				setIsEmailVerified(userDetails?.verified_mail !== false);
				setIsEmailEditing(false);
				setOtpSent(false);
				setEmailOtp("");
				setPhone(normalizePhoneInput(userDetails?.phone || "+1"));
				setAddressString(userDetails?.address || "");
				setGoogleBusinessListing(userDetails?.business_url || "");
				setUuid(userDetails?.user_uuid || "");
				setUserId(userDetails?.user_id || "");
				setBadge(userDetails?.role === "contractor" ? userDetails?.badge || false : false);
				setProfileImageUrl(profile_url + userDetails?.profile_image || null);
				setEmailNotificationsEnabled(userDetails?.email_notifications_enabled !== false);

				localStorage.setItem("profile_image", userDetails?.profile_image || null);
				localStorage.setItem("first_name", userDetails?.first_name || "");
				localStorage.setItem("last_name", userDetails?.last_name || "");

				window.dispatchEvent(new Event("localStorageUpdate"));

				setProfileData({
					first_name: userDetails?.first_name || "",
					last_name: userDetails?.last_name || "",
					business_name: userDetails?.business_name || null,
					email: userEmail,
				});
				setLoading(false);
			} else {
				setLoading(false);
				sweetAlerts("error", response.message || "Failed to get profile details. Please try again.");
			}
		} catch (error) {
			setLoading(false);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		// Load user data from localStorage
		handleGetProfileDetails();
	}, [flagApi]);

	const handleProfileInputChange = (field, value) => {
		setProfileData((prev) => ({
			...prev,
			[field]: value,
		}));

		// Clear error when user starts typing
		if (profileErrors[field]) {
			setProfileErrors((prev) => ({
				...prev,
				[field]: null,
			}));
		}
	};

	const handlePasswordInputChange = (field, value) => {
		setPasswordData((prev) => ({
			...prev,
			[field]: value,
		}));

		// Clear error when user starts typing
		if (passwordErrors[field]) {
			setPasswordErrors((prev) => ({
				...prev,
				[field]: null,
			}));
		}
	};

	const handleEmailEditToggle = () => {
		setIsEmailEditing((prev) => !prev);
		setEmailOtp("");
		setOtpSent(false);
		setProfileErrors((prev) => ({...prev, email: null, emailOtp: null}));

		if (isEmailEditing) {
			setEmail(originalEmail);
			setIsEmailVerified(true);
		} else {
			setIsEmailVerified(false);
		}
	};

	const openOtpModal = (target, value) => {
		setOtpModal({
			open: true,
			target,
			value,
			otp: "",
			loading: false,
			error: null,
		});
	};

	const closeOtpModal = () => {
		setOtpModal((prev) => ({...prev, open: false, otp: "", error: null}));
	};

	const validateProfileForm = () => {
		const errors = {};

		if (!firstName?.trim()) {
			errors.first_name = "First name is required";
		}

		if (!lastName?.trim()) {
			errors.last_name = "Last name is required";
		}

		if (role == contractor_role_id) {
			if (!businessName?.trim()) {
				errors.business_name = "Business name is required";
			}
			// if (!addressString?.trim()) {
			// 	errors.address_string = "Business Address is required";
			// }
		}

		setProfileErrors(errors);
		return Object.keys(errors).length === 0;
	};

	const validatePasswordForm = () => {
		const errors = {};

		if (!passwordData.current_password?.trim()) {
			errors.current_password = "Current password is required";
		}

		if (!passwordData.new_password?.trim()) {
			errors.new_password = "New password is required";
		} else if (passwordData.new_password.length < 6) {
			errors.new_password = "Password must be at least 6 characters";
		} else if (!/[A-Z]/.test(passwordData.new_password)) {
			errors.new_password = "Password must contain at least one uppercase letter";
		} else if (!/[0-9]/.test(passwordData.new_password)) {
			errors.new_password = "Password must contain at least one number";
		}

		if (!passwordData.confirm_password?.trim()) {
			errors.confirm_password = "Please confirm your new password";
		} else if (passwordData.new_password !== passwordData.confirm_password) {
			errors.confirm_password = "Passwords do not match";
		}

		setPasswordErrors(errors);
		return Object.keys(errors).length === 0;
	};

	const handleProfileSubmit = async (e) => {
		e.preventDefault();

		setFormSuccess(null);
		setFormError(null);

		if (!validateProfileForm()) {
			return;
		}

		const emailChanged = email !== originalEmail;
		const normalizedPhone = (phone || "").trim();
		const phoneChanged = normalizedPhone !== (profileData?.phone || "") && normalizedPhone !== "" && normalizedPhone !== "+1";

		if (emailChanged) {
			await sendEmailOtpAndOpen();
			return;
		}

		if (phoneChanged) {
			await sendPhoneOtpAndOpen();
			return;
		}

		await performProfileUpdate();
	};

	const sendEmailOtpAndOpen = async () => {
		setFormSuccess(null);
		setFormError(null);
		setSubmitLoading(true);
		setEmailActionLoading(true);
		try {
			const resp = await SendEmailChangeOtp({new_email: email});
			if (resp?.status) {
				openOtpModal("email", email);
				sweetAlerts("success", "Code sent to your new email.");
				setFormSuccess("Code sent to your new email.");
			} else {
				sweetAlerts("error", resp?.message || "Failed to send Code. Please try again.");
				setFormError(resp?.message || "Failed to send Code. Please try again.");
			}
		} catch (err) {
			sweetAlerts("error", "Failed to send Code. Please try again.");
			setFormError("Failed to send Code. Please try again.");
		} finally {
			setEmailActionLoading(false);
			setSubmitLoading(false);
		}
	};

	const sendPhoneOtpAndOpen = async () => {
		setFormSuccess(null);
		setFormError(null);
		setSubmitLoading(true);
		setPhoneOtpLoading(true);
		const normalizedPhone = (phone || "").trim();
		if (!normalizedPhone || normalizedPhone === "+1") {
			setFormError("Enter a valid phone number (with country code) before requesting Code.");
			setPhoneOtpLoading(false);
			setSubmitLoading(false);
			return;
		}
		try {
			const resp = await BusinessVerifyWithPhoneService({
				uuid,
				phone: normalizedPhone,
				businessName: businessName || null,
				businessAddress: addressString || null,
				businessWebsite: businessWebsite || null,
				googleListing: googleBusinessListing || null,
			});
			if (resp?.status) {
				openOtpModal("phone", phone);
				sweetAlerts("success", resp?.message || "Code sent to your phone.");
				setFormSuccess(resp?.message || "Code sent to your phone.");
			} else {
				sweetAlerts("error", resp?.message || "Phone must match your business (website/address/Google listing).");
				setFormError(resp?.message || "Phone must match your business (website/address/Google listing).");
			}
		} catch (err) {
			sweetAlerts("error", "Failed to send phone Code. Please try again.");
			setFormError("Failed to send phone Code. Please try again.");
		} finally {
			setPhoneOtpLoading(false);
			setSubmitLoading(false);
		}
	};

	const performProfileUpdate = async () => {
		setLoading(true);
		setSubmitLoading(true);
		try {
			const formData = new FormData();
			formData.append("first_name", firstName);
			formData.append("last_name", lastName);
			formData.append("phone", phone);
			formData.append("business_name", businessName || "");
			formData.append("business_website", businessWebsite || "");
			formData.append("address", addressString || "");
			formData.append("email_notifications_enabled", emailNotificationsEnabled);
			formData.append("googleListing", googleBusinessListing || "");
			formData.append("email", email);

			if (profileImage) {
				formData.append("profile_image", profileImage);
			}

			const response = await UpdateProfile(formData);

			if (response.status) {
				localStorage.setItem("first_name", firstName);
				localStorage.setItem("last_name", lastName);
				window.dispatchEvent(new Event("localStorageUpdate"));
				setFlagApi(!flagApi);
				if (profileImage) {
					setProfileImage(null);
					setProfileImagePreview(null);
					handleGetProfileDetails();
				}
				sweetAlerts("success", "Profile updated successfully!");
				setFormSuccess("Profile updated successfully.");
				setFormError(null);
			} else {
				sweetAlerts("error", response.message || "Failed to update profile. Please try again.");
				setFormError(response.message || "Failed to update profile. Please try again.");
				setFormSuccess(null);
			}
		} catch (error) {
			sweetAlerts("error", "Failed to update profile. Please try again.");
			setFormError("Failed to update profile. Please try again.");
			setFormSuccess(null);
		} finally {
			setLoading(false);
			setSubmitLoading(false);
		}
	};

	// Verify Code (email/phone) then perform update
	const verifyOtpAndUpdate = async () => {
		if (!otpModal.otp.trim()) {
			setOtpModal((prev) => ({...prev, error: "Enter the Code."}));
			return;
		}
		setOtpModal((prev) => ({...prev, loading: true, error: null}));
		try {
			if (otpModal.target === "email") {
				const resp = await VerifyEmailAndBusinessChangeOtpService({
					new_email: otpModal.value,
					otp: otpModal.otp,
					uuid,
					businessWebsite: businessWebsite || null,
					businessName: businessName || null,
					businessAddress: addressString || null,
					googleListing: googleBusinessListing || null,
				});
				if (!resp?.status) throw new Error(resp?.message || "Email Code verification failed.");
				setOriginalEmail(otpModal.value);
				setIsEmailVerified(true);
				setOtpSent(false);
				setEmailOtp("");
			} else if (otpModal.target === "phone") {
				const resp = await BusinessVerifyWithPhoneService({
					uuid,
					phone: otpModal.value,
					otp: otpModal.otp,
					businessName: businessName || null,
					businessAddress: addressString || null,
					googleListing: googleBusinessListing || null,
				});
				if (!resp?.status) throw new Error(resp?.message || "Phone Code verification failed.");
			}
			await performProfileUpdate();
			closeOtpModal();
		} catch (err) {
			setOtpModal((prev) => ({...prev, error: err.message || "Code verification failed."}));
		} finally {
			setOtpModal((prev) => ({...prev, loading: false}));
		}
	};

	const handlePasswordSubmit = async (e) => {
		e.preventDefault();

		if (!validatePasswordForm()) {
			return;
		}

		setLoading(true);

		try {
			const response = await ChangePassword({
				oldPassword: passwordData.current_password,
				newPassword: passwordData.new_password,
			});

			if (response.status) {
				// Clear password form
				setPasswordData({
					current_password: "",
					new_password: "",
					confirm_password: "",
				});

				sweetAlerts("success", "Password changed successfully!");
			} else {
				sweetAlerts("error", response.message || "Failed to change password. Please try again.");
			}
		} catch (error) {
			sweetAlerts("error", "Failed to change password. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="my-profile-page">
			<div className="page-header">
				<h2>My Profile</h2>
				<p>Manage your account settings and preferences</p>
			</div>

			<div className="profile-container">
				{/* Tab Navigation */}
				<div className="profile-tabs">
					<button className={`tab-btn ${activeTab === "profile" ? "active" : ""}`} onClick={() => setActiveTab("profile")}>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						Profile
					</button>

					<button className={`tab-btn ${activeTab === "password" ? "active" : ""}`} onClick={() => setActiveTab("password")}>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<circle cx="12" cy="16" r="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path
								d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
						Change Password
					</button>

					<button className={`tab-btn ${activeTab === "business_verification" ? "active" : ""}`} onClick={() => setActiveTab("business_verification")}>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						Business verification
					</button>
				</div>

				{/* Tab Content */}
				<div className="tab-content">
					{/* {activeTab === "profile" && <SignupComponent />} */}

					{activeTab === "profile" && (
						<div className="profile-tab">
							{formSuccess && (
								<Alert severity="success" sx={{mb: 2}}>
									{formSuccess}
								</Alert>
							)}
							{formError && (
								<Alert severity="error" sx={{mb: 2}}>
									{formError}
								</Alert>
							)}
							<form onSubmit={handleProfileSubmit} className="profile-form">
								<div className="form-section w-100 mw-100">
									<h3>Personal Information</h3>
									{badge && (
										<h5 className="changes-preview mb-5">
											Star Contributor badge : <img src={`${process.env.PUBLIC_URL}/img/favicon.png`} width={30} />
											<p className="d-block mt-4 text-success" style={{fontSize: 12}}>
												Congratulations, you became a Start Contributor after leaving more than 5 ratings, comments, or replies.
											</p>
										</h5>
									)}

									<div className="form-group mb-4">
										<label className="form-label">Profile Image</label>
										<div className="profile-image-upload d-flex gap-3 align-items-center">
											{(profileImagePreview || profileImageUrl) && (
												<div className="profile-image-preview">
													<img
														src={profileImagePreview || profileImageUrl}
														alt="Profile"
														onError={(e) => {
															e.target.onerror = null;
															e.target.src =
																"https://plus.unsplash.com/premium_photo-1739786995646-480d5cfd83dc?q=80&w=1480&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
														}}
														style={{width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover", border: "2px solid #ddd"}}
													/>
												</div>
											)}
											<div className="">
												<input
													type="file"
													id="profileImage"
													accept="image/*"
													className="form-input"
													style={{display: "none"}}
													onChange={(e) => {
														const file = e.target.files[0];
														if (file) {
															if (file.size > 5 * 1024 * 1024) {
																sweetAlerts("error", "Image size should be less than 5MB");
																return;
															}
															setProfileImage(file);
															const reader = new FileReader();
															reader.onloadend = () => {
																setProfileImagePreview(reader.result);
															};
															reader.readAsDataURL(file);
														}
													}}
												/>

												<div className="d-flex d-sm-grid gap-2">
													<Button component="label" htmlFor="profileImage" variant="contained" color="success">
														{profileImagePreview || profileImageUrl ? "Change Image" : "Upload Image"}
													</Button>
													{(profileImagePreview || profileImageUrl) && (
														<Button
															variant="contained"
															color="error"
															onClick={() => {
																setProfileImage(null);
																setProfileImagePreview(null);
																setProfileImageUrl(null);
																document.getElementById("profileImage").value = "";
															}}>
															Remove
														</Button>
													)}
												</div>

												{/* <Button variant="contained">{profileImagePreview || profileImageUrl ? "Change Image" : "Upload Image"}</Button> */}
												{/* <label htmlFor="profileImage" className="btn btn-primary btn-large" style={{cursor: "pointer", margin: 0}}>
													{profileImagePreview || profileImageUrl ? "Change Image" : "Upload Image"}
												</label> */}

												{/* {(profileImagePreview || profileImageUrl) && (
													<button
														type="button"
														onClick={() => {
															setProfileImage(null);
															setProfileImagePreview(null);
															setProfileImageUrl(null);
															document.getElementById("profileImage").value = "";
														}}
														className="btn btn-sm btn-danger btn-large"
														>
														Remove
													</button>
												)} */}
											</div>
										</div>
										<small className="form-help">Upload a profile image (max 5MB, JPG/PNG)</small>
									</div>

									<div className="form-row">
										<div className="form-group">
											<label className="form-label">First Name *</label>
											<input
												type="text"
												className={`form-input ${profileErrors.first_name ? "error" : ""}`}
												value={firstName}
												onChange={(e) => setFirstName(e.target.value)}
												placeholder="Enter your first name"
											/>
											{profileErrors.first_name && <div className="error-message">{profileErrors.first_name}</div>}
										</div>

										<div className="form-group">
											<label className="form-label">Last Name *</label>
											<input type="text" className={`form-input ${profileErrors.last_name ? "error" : ""}`} value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Enter your last name" />
											{profileErrors.last_name && <div className="error-message">{profileErrors.last_name}</div>}
										</div>
									</div>

									{role == contractor_role_id && (
										<div className="form-group">
											<label className="form-label">Business Name *</label>
											<input
												type="text"
												className={`form-input ${profileErrors.business_name ? "error" : ""}`}
												value={businessName}
												onChange={(e) => setBusinessName(e.target.value)}
												placeholder="Enter your business name"
											/>
											{profileErrors.business_name && <div className="error-message">{profileErrors.business_name}</div>}
										</div>
									)}

									{role == contractor_role_id && (
										<div className="form-group">
											<label className="form-label">
												Business Website <span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>(e.g. https://example.com)</span>
											</label>
											<input type="text" className="form-input" value={businessWebsite} onChange={(e) => setBusinessWebsite(e.target.value)} placeholder="Enter your business website" />
										</div>
									)}

									{role == contractor_role_id && (
										<div className="form-group">
											<label htmlFor="address" className="form-label">
												Business Address
											</label>
											<GoogleAddress
												styleFlag="loginStyle"
												address={addressString}
												callBackAction={(val) => {
													setAddressString(val.value);
												}}
											/>
											{profileErrors.address_string && <span className="error-text">{profileErrors.address_string}</span>}
										</div>
									)}

									{/* {role == contractor_role_id && (
										<div className="form-group">
											<label htmlFor="googleListing" className="form-label">
												Google Business Listing <br />
												<span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}> </span>
											</label>

											<input
												type="text"
												id="googleListing"
												className="form-input"
												placeholder="Enter your Google Business Listing"
												value={googleBusinessListing}
												onChange={(e) => {
													setGoogleBusinessListing(e.target.value);
												}}
											/>
											{profileErrors.googleListing && <span className="error-text">{profileErrors.googleListing}</span>}
										</div>
									)} */}

									{/* <div className="form-group">
										<label className="form-label">Email *</label>
										<input type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email address" />
										{profileErrors.email && <div className="error-message">{profileErrors.email}</div>}
									</div>

									<div className="form-group">
										<label className="form-label">Phone</label>
										<input type="text" className="form-input" value={phone} onChange={(e) => setPhone(normalizePhoneInput(e.target.value))} placeholder="Enter your phone number" />
										{profileErrors.phone && <div className="error-message">{profileErrors.phone}</div>}
									</div> */}

									<div className="form-group">
										<label className="form-label">Email Notifications</label>
										<div style={{display: "flex", alignItems: "center", gap: "10px"}}>
											<FormControlLabel
												control={<Switch checked={emailNotificationsEnabled} onChange={(e) => setEmailNotificationsEnabled(e.target.checked)} color="primary" />}
												label={emailNotificationsEnabled ? "Enabled" : "Disabled"}
											/>
										</div>
										<small className="form-help">Receive email notifications for dashboard activities</small>
									</div>
								</div>

								<div className="form-actions">
									<button type="submit" className="btn btn-primary" disabled={loading || submitLoading}>
										{loading || submitLoading ? (
											<>
												<span className="spinner-small"></span>
												Updating...
											</>
										) : (
											"Update Profile"
										)}
									</button>
								</div>
							</form>
						</div>
					)}

					{activeTab === "password" && (
						<div className="password-tab">
							<form onSubmit={handlePasswordSubmit} className="password-form">
								<div className="form-section w-100 mw-100">
									<h3>Change Password</h3>
									<p className="form-description">Enter your current password and choose a new secure password.</p>

									<div className="form-group">
										<label className="form-label">Current Password *</label>
										<input
											type="password"
											className={`form-input ${passwordErrors.current_password ? "error" : ""}`}
											value={passwordData.current_password}
											onChange={(e) => handlePasswordInputChange("current_password", e.target.value)}
											placeholder="Enter your current password"
										/>
										{passwordErrors.current_password && <div className="error-message">{passwordErrors.current_password}</div>}
									</div>

									<div className="form-group">
										<label className="form-label">New Password *</label>
										<input
											type="password"
											className={`form-input ${passwordErrors.new_password ? "error" : ""}`}
											value={passwordData.new_password}
											onChange={(e) => handlePasswordInputChange("new_password", e.target.value)}
											placeholder="Enter your new password"
										/>
										{passwordErrors.new_password && <div className="error-message">{passwordErrors.new_password}</div>}
										<small className="form-help">Password must be at least 6 characters with uppercase letter and number</small>
									</div>

									<div className="form-group">
										<label className="form-label">Confirm New Password *</label>
										<input
											type="password"
											className={`form-input ${passwordErrors.confirm_password ? "error" : ""}`}
											value={passwordData.confirm_password}
											onChange={(e) => handlePasswordInputChange("confirm_password", e.target.value)}
											placeholder="Confirm your new password"
										/>
										{passwordErrors.confirm_password && <div className="error-message">{passwordErrors.confirm_password}</div>}
									</div>
								</div>

								<div className="form-actions">
									<button type="submit" className="btn btn-primary" disabled={loading}>
										{loading ? (
											<>
												<span className="spinner-small"></span>
												Changing...
											</>
										) : (
											"Change Password"
										)}
									</button>
								</div>
							</form>
						</div>
					)}

					{activeTab === "business_verification" && <CustomBusinessVerifiedMain />}

					<Dialog open={otpModal.open} onClose={closeOtpModal} maxWidth="xs" fullWidth>
						<DialogTitle>Verify {otpModal.target === "email" ? "Email" : "Phone"}</DialogTitle>
						<DialogContent>
							<p style={{marginBottom: 10}}>Enter the Code sent to {otpModal.value}</p>
							<input
								type="text"
								className="form-input"
								maxLength="6"
								placeholder="123456"
								value={otpModal.otp}
								onChange={(e) => setOtpModal((prev) => ({...prev, otp: e.target.value.replace(/\D/g, ""), error: null}))}
							/>
							{otpModal.error && <div className="error-message mt-2">{otpModal.error}</div>}
						</DialogContent>
						<DialogActions>
							<Button onClick={closeOtpModal} disabled={otpModal.loading}>
								Cancel
							</Button>
							{otpModal.target === "email" && (
								<Button onClick={sendEmailOtpAndOpen} disabled={otpModal.loading || submitLoading || emailActionLoading} variant="text">
									{emailActionLoading ? "Resending..." : "Resend Code"}
								</Button>
							)}
							{otpModal.target === "phone" && (
								<Button onClick={sendPhoneOtpAndOpen} disabled={otpModal.loading || submitLoading || phoneOtpLoading} variant="text">
									{phoneOtpLoading ? "Resending..." : "Resend Code"}
								</Button>
							)}
							<Button variant="contained" onClick={verifyOtpAndUpdate} disabled={otpModal.loading || submitLoading}>
								{otpModal.loading || submitLoading ? "Verifying..." : "Verify & Save"}
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</div>
		</div>
	);
};

export default MyProfile;
